<template>
	<Card
		v-if="(!cookieStore.hasChosen && !isTemporarilyClosed) || forceOpen"
		class="right-view-padding left-view-padding bottom-view-padding fixed! z-1999 w-auto! shadow-lg sm:left-auto sm:w-140! sm:max-w-[80vw]!"
		bordered
		content-class="flex flex-col gap-4"
	>
		<template #header>
			<div class="flex w-full items-center justify-between">
				<p class="text-fs-xs">{{ $t("cookie_banner.title") }}</p>
				<JMButton type="secondary" size="small" icon-name="carbon:close" circle @click="closeTemporarily" />
			</div>
		</template>
		<div
			class="text-fs-xs flex flex-col gap-0.5"
			v-html="$t('cookie_banner.message', { link: cookiePolicyUrl })"
		></div>
		<div class="flex gap-2">
			<JMButton type="secondary" size="small" @click="acceptEssentialOnly">
				{{ $t("cookie_banner.accept_essential_only") }}
			</JMButton>
			<JMButton type="primary" size="small" @click="acceptAll">
				{{ $t("cookie_banner.accept_all") }}
			</JMButton>
		</div>
	</Card>
</template>

<script lang="ts" setup>
import { ref } from "vue"
import Card from "@/components/common/Card.vue"
import JMButton from "@/components/common/JMButton.vue"
import { useCookieConsentStore } from "@/stores/cookieConsent"

const cookieStore = useCookieConsentStore()
const cookiePolicyUrl = import.meta.env.VITE_LINK_COOKIE_POLICY
const isTemporarilyClosed = ref(false)
const forceOpen = ref(false)

function closeTemporarily() {
	isTemporarilyClosed.value = true
	forceOpen.value = false
}

function reopen() {
	isTemporarilyClosed.value = false
	forceOpen.value = true
}

function acceptAll() {
	cookieStore.setAnalyticsAccepted(true)
	forceOpen.value = false
	isTemporarilyClosed.value = true
}

function acceptEssentialOnly() {
	cookieStore.setAnalyticsAccepted(false)
	forceOpen.value = false
	isTemporarilyClosed.value = true
}

defineExpose({
	reopen
})
</script>
